import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const getSupplierOnboardingStatus = (supplierId) => async (dispatch) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/supplier/${supplierId}/onboarding-status`,
			'',
			true
		);
		dispatch({
			type: Types.SAVE_SUPPLIER_ONBOARDING_STATUS,
			payload: data
		});
	} catch (e) {
		printApiError(e);
	}
};

export const getSupplierInfo = (supplierId) => async (dispatch) => {
	try {
		const { data } = await ApiClient.GET('supplierInfo', `/${supplierId}`);
		dispatch({
			type: Types.SAVE_SUPPLIER_INFORMATION,
			payload: data
		});
	} catch (e) {
		printApiError(e);
	}
};

export const getSupplierBankInfo = (supplierId) => async (dispatch) => {
	try {
		const { data } = await ApiClient.GET('supplierBankInfo', `/${supplierId}`);
		dispatch({
			type: Types.SAVE_SUPPLIER_BANK_INFORMATION,
			payload: data
		});
	} catch (e) {
		printApiError(e);
	}
};
export const getSupplierCategoryStrengths = async () => {
	try {
		const { data } = await ApiClient.GET('supplierProductCategoryStrengths');
		return data.map((item) => ({ label: item.name, value: item.constant }));
	} catch (e) {
		printApiError(e);
	}
};

export const getSupplierDocuments =
	(supplierId, isAdditionalDocument = false) =>
	async (dispatch) => {
		try {
			const { data } = await ApiClient.GET(
				`${BASE_URL}/supplier/${supplierId}/documents?isAdditionalDocument=${isAdditionalDocument}`,
				'',
				true
			);
			dispatch({
				type: Types.SAVE_SUPPLIER_DOCUMENTS,
				payload: data
			});
		} catch (e) {
			printApiError(e);
		}
	};

export const getSupplierPhotoDocuments = async (supplierId) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/supplier/${supplierId}/reference-documents`,
			'',
			true
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const addRejectedField = (supplierId, postData) => async (dispatch) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/add-rejected-field`, postData, '', true);
		await dispatch(getSupplierOnboardingStatus(supplierId));
	} catch (e) {
		printApiError(e);
	}
};

export const removeRejectedField = (supplierId, postData) => async (dispatch) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/remove-rejected-field`, postData, '', true);
		await dispatch(getSupplierOnboardingStatus(supplierId));
	} catch (e) {
		printApiError(e);
	}
};

export const rejectOnboardingRequest = (supplierId) => async (dispatch) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/reject`, {}, '', true);
		await dispatch(getSupplierOnboardingStatus(supplierId));
	} catch (e) {
		printApiError(e);
	}
};

export const approveOnboardingRequest = (supplierId) => async (dispatch) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/approve`, {}, '', true);
		await dispatch(getSupplierOnboardingStatus(supplierId));
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierDocument = async (supplierId, postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/add-document`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const addBulkSupplierDocument = async (supplierId, postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/add-document/bulk`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierPhotoDocument = async (supplierId, postData) => {
	try {
		await ApiClient.POST('addSupplierPhotoDocuments', postData, `/${supplierId}`);
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierMaterialDocument = async (postData) => {
	try {
		const { data } = await ApiClient.POST('getUploadMaterialDoc', postData, ``);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierProduct = async (supplierId, postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/products/${supplierId}/add`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const updateSupplierProduct = async (supplierId, postData) => {
	try {
		await ApiClient.PUT(`${BASE_URL}/supplier/products/${supplierId}/edit`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const addAccessories = async (postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/material/branding/branding-with-supplier/add`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const addTrims = async (postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/material/trims/trims-with-supplier/add`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const removeKeyCustomerBrand = async (supplierId, brandId) => {
	try {
		await ApiClient.DELETE(`${BASE_URL}/supplier/${supplierId}/brands/${brandId}`, '', '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const removeSupplierDocuments = async (supplierId, docId) => {
	try {
		await ApiClient.DELETE(
			`${BASE_URL}/supplier/${supplierId}/delete-supplier-doc/${docId}`,
			'',
			'',
			true
		);
	} catch (e) {
		printApiError(e);
	}
};

export const removeDocById = async (docId) => {
	try {
		await ApiClient.DELETE(`${BASE_URL}/doc/${docId}`, '', '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const getCompositionParts = async (selected) => {
	try {
		const { data } = await ApiClient.GET(
			'getCompositionParts',
			`?compositionDetails=` + encodeURIComponent(selected)
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const addFabricWithSupplier = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('addFabricWithSupplier', requestBody);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const getTrimsAndAccessoriesQuality = async (type) => {
	try {
		const { data } = await ApiClient.GET('getAllTags', `?page=0&size=1000&type=${type}`);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const getTrimsAndAccessoriesCategories = async (params, type) => {
	try {
		const { data } = await ApiClient.GET(
			type === 'ACCESSORIES' ? 'materialCategories' : 'trimsSubCategories',
			`/${params}`
		);
		let tmpCategories = [];
		for (let cat of data) {
			for (let item of cat.subCategoryResponseList) {
				tmpCategories.push({ ...item, value: item.name });
			}
		}
		return tmpCategories;
	} catch (e) {
		printApiError(e);
	}
};

export const addTeamMember = async (supplierId, postData) => {
	try {
		await ApiClient.POST(`${BASE_URL}/supplier/${supplierId}/add-team-member`, postData, '', true);
	} catch (e) {
		printApiError(e);
	}
};

export const updateTeamMemberStatus = async (userId, postData) => {
	try {
		await ApiClient.POST('updateUserStatus', postData, `/${userId}`);
	} catch (e) {
		printApiError(e);
	}
};

export const fetchTeamMembers = async (supplierId) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/supplier/${supplierId}/team-member`, '', true);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const fetchSafetyInformation = async (supplierId) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/supplier/${supplierId}/safety-information`,
			'',
			true
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const updateSafetyInformation = async (supplierId, postData) => {
	try {
		await ApiClient.PUT(
			`${BASE_URL}/supplier/${supplierId}/update-safety-information`,
			postData,
			'',
			true
		);
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierSafetyDocument = async (supplierId, postData) => {
	try {
		await ApiClient.POST(
			`${BASE_URL}/supplier/${supplierId}/add-document-with-doc-type`,
			postData,
			'',
			true
		);
	} catch (e) {
		printApiError(e);
	}
};

export const addSupplierAdditionalDocument = async (supplierId, postData) => {
	try {
		await ApiClient.POST(
			`${BASE_URL}/supplier/${supplierId}/add-document-with-doc-type/bulk`,
			postData,
			'',
			true
		);
	} catch (e) {
		printApiError(e);
	}
};

export const getSupplierCertificates = async (supplierId) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/supplier/${supplierId}/certificates`, '', true);
		return data;
	} catch (e) {
		printApiError(e);
	}
};
